import { render, staticRenderFns } from "./ProjectTableCoupon.vue?vue&type=template&id=273b2ad3&"
import script from "./ProjectTableCoupon.vue?vue&type=script&lang=js&"
export * from "./ProjectTableCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTableCoupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports